import React, {useEffect, useState} from "react";
import useQueryParams from "../../utils/hooks/useQueryParams";
import {getParams} from "../../utils/hooks/getParams";
import {useDispatch} from "react-redux";

const FilterByInStock = ({getPageItems}) => {
    const dispatch = useDispatch();

    const {in_stock, page} = useQueryParams();
    const [inStockValue, setInStockValue] = useState(in_stock ? in_stock : '');
    const [isFirst, setIsFirst] = useState(true);

    useEffect(() => {
        setIsFirst(false);
    }, [])
    useEffect(() => {
        if (!isFirst) {
            const timeOutId = setTimeout(() => onChangeInStock(inStockValue), 1000);
            return () => clearTimeout(timeOutId);
        }
    }, [inStockValue]);

    const onChangeInStock = (inStockInput) => {
        if (inStockInput !== '') {
            setInStockValue(inStockInput);
            const url = new URL(window.location);
            url.searchParams.set('in_stock', inStockInput);
            url.searchParams.set('page', 1);
            window.history.pushState({}, '', url);
            const params = getParams();
            if (params['in_stock']) delete params['page'];
            dispatch(getPageItems(1, params));

        } else {
            setInStockValue('');
            const url = new URL(window.location);
            url.searchParams.delete('in_stock');
            url.searchParams.set('page', 1);
            window.history.pushState({}, '', url);
            const params = getParams();
            if (params['in_stock']) delete params['in_stock'];
            dispatch(getPageItems(1, params));
        }
    };

    return (
        <input type="search" placeholder="Qolgan miqdori gacha" value={inStockValue}
               className="form-control"
               id="inputSearch"
               onChange={e => setInStockValue(e.target.value)}/>
    )
};

export default FilterByInStock; 